import {useLocation} from 'react-router-dom';

export const useCurrentTabTitle = () => {
  const path = useLocation().pathname.split('/');
  const pathTitle = path[1].charAt(0).toUpperCase() + path[1].slice(1);

  return `${pathTitle || 'Welcome'} - Digistaff`;
};
